import { create } from 'zustand';

interface SelectedProject {
  id: string;
  title: string;
  client_name?: string;
}

interface ProjectSelectionState {
  selectedProject: SelectedProject | null;
  selectProject: (project: SelectedProject) => void;
  clearSelection: () => void;
}

export const useProjectSelectionStore = create<ProjectSelectionState>((set) => ({
  selectedProject: (() => {
    try {
      const saved = localStorage.getItem('selected-project');
      return saved ? JSON.parse(saved) : null;
    } catch {
      return null;
    }
  })(),

  selectProject: (project) => {
    localStorage.setItem('selected-project', JSON.stringify(project));
    set({ selectedProject: project });
  },

  clearSelection: () => {
    localStorage.removeItem('selected-project');
    set({ selectedProject: null });
  },
}));
